import { useEffect } from 'react';

// A very long phrase must still fit a narrow card or mobile column. Observe
// live CMS headings as well as route changes, without changing their text.
export default function HeadingLayout() {
  useEffect(() => {
    const widths = new WeakMap();
    let frame;
    let force = false;
    const fit = () => {
      const refresh = force;
      force = false;
      for (const heading of document.querySelectorAll('h1,h2,h3,h4,h5,h6')) {
        const width = heading.clientWidth;
        if (!width || (!refresh && widths.get(heading) === width)) continue;
        widths.set(heading, width);
        heading.style.removeProperty('font-size');
        const phrases = [...heading.querySelectorAll('.heading-phrase')];
        const longest = Math.max(0, ...phrases.map(phrase => phrase.getBoundingClientRect().width));
        if (longest > width) {
          const size = parseFloat(getComputedStyle(heading).fontSize);
          heading.style.fontSize = `${size * width / longest * 0.98}px`;
        }
      }
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(fit);
    };
    const resize = new ResizeObserver(schedule);
    const observe = () => {
      document.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(heading => resize.observe(heading));
      schedule();
    };
    const mutations = new MutationObserver(observe);
    mutations.observe(document.getElementById('root'), {subtree:true,childList:true});
    const refresh = () => { force = true; schedule(); };
    window.addEventListener('resize', refresh);
    document.fonts.ready.then(refresh);
    observe();
    return () => {
      cancelAnimationFrame(frame);
      resize.disconnect();
      mutations.disconnect();
      window.removeEventListener('resize', refresh);
    };
  }, []);
  return null;
}
